import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import CellRendererActions from "@/components/skills/cell-renderer/CellRendererActions.vue";
import moduleSkills from "@/store/skills/moduleSkills.js";

window.numberParser = function numberParser(params) {
	return Number(params.newValue) | 0;
};

export const skillListMixin = {
	name: "SkillList",
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					rowSelection: "multiple",
					showPopup: false,
					activeCheckbox: false,
					activeHeaderCheckboxSelection: false,
					activeLink: true,
					columns: [],
					tableOptions: true,
					showItemsPerPage: true,
					showSearch: true,
					showActions: true,
					btnAssig: true,
				};
			},
		},
		status_id: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		AgGridVue,
		vSelect,
		CellRendererActions,
	},
	data() {
		return {
			searchQuery: [],
			currentPageLocal: 1,
			quantityElementPage: 10,
			searchField: "Name",
			gridApi: null,
			gridOptions: {},
			loadingOverlayComponent: null,
			loadingOverlayComponentParams: null,
			isExactly: false,
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
				flex: 1,
			},
			components: {
				CellRendererActions,
			},
		};
	},
	watch: {
		currentPageLocal(page) {
			this.getSkills(page);
		},
		quantityElementPage() {
			this.getSkills(1);
		},
	},
	created() {
		if (!moduleSkills.isRegistered) {
			this.$store.registerModule("moduleSkills", moduleSkills);
			moduleSkills.isRegistered = true;
		}
	},
	async mounted() {
		this.gridApi = this.gridOptions.api;
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}
		const matchFilter = await this.$store.dispatch("moduleMatchFilter/getMatchFilter");
		if (Object.entries(matchFilter) > 0) {
			this.isExactly = matchFilter.filter_exact_skill;
		} else {
			this.isExactly = this.$store.state.moduleMatchFilter.filter_exact_skill;
		}
		this.getSkills(1);
	},
	beforeDestroy() {
		this.removeNotify();
		this.$store.commit("moduleSkills/REMOVE_ALL_SKILL_CHECKED");
	},
	computed: {
		overlayLoadingTemplate() {
			return `<div class="ring">${this.$t("Loading")}<span></span></div>`;
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		columnDefs() {
			let filterHead = this.customConfig.filterHead !== undefined ? this.customConfig.filterHead : true;
			let columns = [
				{
					headerName: "ID",
					field: "id",
					width: 150,
					filter: filterHead,
					checkboxSelection: this.customConfig.activeCheckbox,
					headerCheckboxSelectionFilteredOnly: true,
					headerCheckboxSelection: this.customConfig.activeHeaderCheckboxSelection,
				},
				{
					headerName: this.$t("Routing.Table.Name"),
					field: "name",
					filter: filterHead,
					width: 250,
				},
				{
					headerName: this.$t("Description"),
					field: "description",
					filter: filterHead,
					width: 500,
				},
				{
					headerName: "No. " + this.$t("Vehicles.Vehicles"),
					field: "amountVehicles",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: "No. " + this.$t("Routing.Title.VisitPoints"),
					field: "amountVisitPoints",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("BreakTable.Action"),
					field: "transactions",
					width: 120,
					cellRendererFramework: "CellRendererActions",
					pinned: "right",
				},
			];
			if (this.customConfig.CellRendererDemand) {
				columns.splice(2, 0, {
					headerName: this.$t("Routing.Table.Demand"),
					field: "demand",
					filter: filterHead,
					editable: true,
					width: 130,
					cellRendererFramework: "CellRendererDemandText",
					valueParser: numberParser,
				});
			}
			if (this.customConfig.CellRendererTypeService) {
				columns.splice(3, 0, {
					headerName: this.$t("TypeOfService"),
					field: "typeService",
					filter: filterHead,
					editable: true,
					width: 180,
					cellRendererFramework: "CellRendererTypeServiceText",
					cellEditor: "agSelectCellEditor",
					cellEditorParams: {values: [this.$t("PICKUP"), this.$t("DELIVERY")]},
				});
			}
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}
			return columns;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			} else {
				return 0;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		searchSelected() {
			return this.$t(`${this.searchField}`);
		},
		usersData() {
			return this.$store.state.moduleSkills.skills;
		},
		getCheckedSkills() {
			return this.$store.state.moduleSkills.checkedSkills;
		},
		isWidthPortatil() {
			return window.innerWidth <= 1366;
		},
	},
	methods: {
		getSkills(page) {
			this.onBtShowLoading();
			const payload = {
				sort: "desc",
				page,
				quantity: this.quantityElementPage,
				match_filter: !this.isExactly,
				order_by: ["id"],
			};
			this.$store
				.dispatch("moduleSkills/findSkillPaginateFilter", payload)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		rowSelected(event) {
			const isSelected = event.node.isSelected();
			if (isSelected) {
				this.$store.commit("moduleSkills/ADD_SKILL_CHECKED", event.data);
			} else {
				this.$store.commit("moduleSkills/REMOVE_SKILL_CHECKED", event.data);
			}
		},
		setDefaultSelectedRow() {
			const relatedIds = this.getCheckedSkills;
			if (relatedIds.length > 0) {
				this.gridApi.forEachNode((node) => {
					const valid = relatedIds.some((r) => r.id === node.data.id);
					node.setSelected(valid);
				});
			}
		},
		search() {
			const searchQueryList = this.searchQuery.map(({value}) => {
				if (this.searchField === "Id") return parseInt(value);
				return value;
			});
			const dataPage = {
				id: this.searchField === "Id" ? searchQueryList : [],
				name: this.searchField === "Name" ? searchQueryList : [],
				match_filter: !this.isExactly,
				order_by: ["id"],
				sort: "asc",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("moduleSkills/findSkillPaginateFilter", dataPage)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		generateOptionSelect(data, propLabel, propValue) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
		refresh() {
			this.searchQuery = [];
			this.currentPageLocal = 1;
			this.$store.commit("moduleSkills/REMOVE_ALL_SKILL_CHECKED");
			this.getSkills(1);
			this.removeNotify();
		},
		setSearchField(val) {
			this.searchField = val;
		},
		addNewData() {
			this.$router.push({name: "NewSkill"});
		},
		onBtShowLoading() {
			this.gridApi.showLoadingOverlay();
		},
		onBtHide() {
			this.gridApi.hideOverlay();
		},
		deleteRecordById(id) {
			this.$store
				.dispatch("moduleSkills/removeItem", id)
				.then((res) => {
					this.$store.commit("moduleSkills/REMOVE_ID_SKILL", id);
					return res;
				})
				.catch((err) => {
					return err;
				});
		},
		removeNotify() {
			if (this.$store.state.moduleSkills.skillIds.length > 0) {
				for (let id of this.$store.state.moduleSkills.skillIds) {
					this.deleteRecordById(id);
				}
				let notifyActive = document.querySelectorAll(".vs-notifications");
				for (const notify of notifyActive) {
					notify.classList.remove("vs-notifications");
				}
			}
		},
		openEnableConfirm(val) {
			if (val) {
				this.$vs.dialog({
					type: "confirm",
					color: "primary",
					title: this.$t("Confirm"),
					text: `${this.$t("Preferences.FilterSearchExactText")}`,
					accept: () => {
						this.isExactly = val;
						this.updateMatchFilter();
					},
					cancel: () => {
						this.isExactly = false;
					},
					acceptText: this.$t("Accept"),
					cancelText: this.$t("Cancel"),
				});
			} else {
				this.isExactly = val;
				this.updateMatchFilter();
			}
		},
		async updateMatchFilter() {
			const payload = {};
			payload["filter_exact_skill"] = this.isExactly;
			try {
				await this.$store.dispatch("moduleMatchFilter/updateMatchFilter", payload);
			} catch (error) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("ErrorTitle"),
					text: this.$t("ErrorMessage"),
				});
			}
		},
	},
};
